export default __webpack_public_path__ + "static/media/StepsActive03.fe0a2d28.svg";